import React from 'react';
import { useSelector } from 'react-redux';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getProductCardLabels } from '@yme/pdp-components/ProductCard';
import { getRTL } from '@yme/selectors/index';
import { colorBrandYamahaRed, colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { PriceDisclaimerText } from './PriceDisclaimerText';
import { StrikethroughTextStyled, UnitPriceLabelStyled, UnitPriceStyled, UnitPriceWrapperStyled, } from './styled';
export function UnitPrice({ formattedPrice, isMarginTop = true, showDiscount = false, amountPrice = '', campaignDisclaimer, lastMonthDiscountObject, }) {
    const isRightToLeft = useSelector(getRTL);
    const labels = useSelector(getProductCardLabels);
    const { isMobileView } = useWindowSize();
    return (React.createElement(React.Fragment, null,
        React.createElement(UnitPriceWrapperStyled, { isMarginTop: isMarginTop },
            React.createElement(FlexWrapper, { isFullWidth: true, justifyContent: "space-between", alignItems: isMobileView ? 'center' : undefined },
                labels?.productCard_total_label && (React.createElement(UnitPriceLabelStyled, null, `${labels?.productCard_total_label}:`)),
                React.createElement(UnitPriceStyled, { isRightToLeft: isRightToLeft },
                    amountPrice.length && showDiscount && (React.createElement(StrikethroughTextStyled, null, amountPrice)),
                    formattedPrice)),
            React.createElement(PriceDisclaimerText, { campaignDisclaimer: campaignDisclaimer })),
        lastMonthDiscountObject && (React.createElement(FlexWrapper, { flexDirection: "column", alignItems: "flex-start", mt: "24px" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 },
                `${labels.productCard_lowestPrice_label}: `,
                `${lastMonthDiscountObject.formattedLastLowestPrice} `,
                React.createElement(RegularTextLevel4, { color: colorBrandYamahaRed },
                    "(",
                    `${lastMonthDiscountObject.discountPercentFromLatestLowerPrice}`,
                    ")")),
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 },
                `${labels.productCard_regularPrice_label}: `,
                `${lastMonthDiscountObject.formattedRegularPrice} `,
                lastMonthDiscountObject.currentDiscountPercent && (React.createElement(RegularTextLevel4, { color: colorBrandYamahaRed },
                    "(",
                    `-${lastMonthDiscountObject.currentDiscountPercent}%`,
                    ")")))))));
}
UnitPrice.displayName = 'UnitPrice_Component';
